import { render, staticRenderFns } from "./UserEditSettings.vue?vue&type=template&id=7da899e3&"
import script from "./UserEditSettings.vue?vue&type=script&lang=js&"
export * from "./UserEditSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports